import React from 'react';
import { useNavigate } from 'react-router-dom';

const Services = () => {
  const navigate = useNavigate();
  
  const services = [
    {
      id: 1,
      icon: 'bi-card-checklist',
      title: 'Contract Manufacturing',
      description: 'In the rapidly evolving pharmaceutical industry, outsourcing production to trusted experts is key to staying competitive. Swotonn Labs provides end-to-end contract manufacturing services, helping pharmaceutical firms scale their operations without compromising on quality or efficiency.Provident nihil minus qui consequatur non omnis maiores. Eos accusantium minus dolores iure perferendis tempore et consequatur.',
      delay: 100
    },
    {
      id: 2,
      icon: 'bi-briefcase',
      title: 'Licensing & Partnerships',
      description: 'Collaboration is at the heart of innovation in healthcare. At Swotonn Labs, we actively engage in licensing and partnerships to bring groundbreaking drugs to market. Our team works closely with pharmaceutical innovators, biotechnology firms, and research institutions to ensure the successful commercialization of life-saving medications.',
      delay: 100
    },
    
  ];

  const handleServiceClick = (service) => {
    navigate(`/service-details/${service.id}`, { state: { service } });
  };

  return (
    <section id="services" className="services section light-background">
      <div className="container section-title" data-aos="fade-up">
        <span>Services</span>
        <h2>Services</h2>
        <p>We also provide following services</p>
      </div>

      <div className="container">
        <div className="row gy-4">
          {services.map((service, index) => (
            <div key={index} className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay={service.delay}>
              <div className="service-item position-relative" style={{ cursor: 'pointer' }} onClick={() => handleServiceClick(service)}>
                <div className="icon">
                  <i className={`bi ${service.icon}`}></i>
                </div>
                <div className="stretched-link">
                  <h3>{service.title}</h3>
                </div>
                <p>{service.description.substring(0, 250)+"..."}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
